import { render } from "./CrStepSurface1Content.vue?vue&type=template&id=c06644e6&scoped=true"
import script from "./CrStepSurface1Content.vue?vue&type=script&lang=js"
export * from "./CrStepSurface1Content.vue?vue&type=script&lang=js"

import "./CrStepSurface1Content.vue?vue&type=style&index=0&id=c06644e6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c06644e6"]])

export default __exports__